import React, { useContext } from 'react';
import { AuthContext } from '../../context/auth';
import Footer from '../../components/Footer';
import MenuPrincipaCatastro from '../../components/catastro/menuPrincipalCatastro';

function Catastro() {
  const { user } = useContext(AuthContext);
  return (
    user && (
      <div style={{ height: "100vh", padding: 0 }}>
          <MenuPrincipaCatastro/>
          <Footer />
      </div>
    )
  );
}
export default Catastro;
